export function useWhatsApp(restaurant: UseWhatsAppRestaurant): boolean {
  return restaurant.account.features.whatsApp && restaurant.messages.useWhatsApp;
}

interface UseWhatsAppRestaurant {
  messages: {
    useWhatsApp: boolean;
  };
  account: {
    features: {
      whatsApp: boolean;
    };
  };
}
